/* eslint-disable no-console */
/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import ErrorPage from './ErrorPage';
import { HasError } from './types';

class ErrorBoundary extends React.Component {
  static getDerivedStateFromError(): HasError {
    window.sessionStorage.route = window.location.href;
    window.sessionStorage.browser = window.navigator.userAgent;
    return { hasError: true };
  }

  public state: {
    hasError: boolean;
    errorName: string;
    errorStack: string;
  };

  constructor(props: { hasError: boolean } | Readonly<{ hasError: boolean }>) {
    super(props);
    this.state = {
      hasError: false,
      errorName: '',
      errorStack: ''
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.log('Error :::', error.name);
    console.log('Error Stack ::: ', errorInfo.componentStack);
    this.setState({
      hasError: true,
      errorName: error.name,
      errorStack: errorInfo.componentStack
    });
  }

  render(): React.ReactElement {
    const { hasError, errorName, errorStack } = this.state;
    const { children } = this.props;
    if (hasError) {
      return <ErrorPage errorName={errorName} errorStack={errorStack} />;
    }
    return <React.Fragment>{children}</React.Fragment>;
  }
}

export default ErrorBoundary;
